import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import {
  GeaMesLoginComponent,
  GeaMesCognitoAuthGuard,
  GeaMesCognitoModule,
  COGNITO_CONFIG_HA,
  GeaMesAuthInterceptor,
  APPLICATION_NAME, APIGATEWAY_CONFIG, GeaMesCognitoAuthService,ALLOW_SCREENAUTH,
  GeaMesLogoutComponent,
  GeaMesAccessDeniedComponent
} from '@gea-mes/cognito';
import { environment } from 'src/environments/environment';
import { appinfo } from './appinfo';
import { GEA_MES_NAVBAR_APPLICATION_NAME, GEA_MES_NAVBAR_MENU_SERVICE, GEA_MES_NAVBAR_ENV_PROD_STATUS, GEA_ENVIROMENT,GEA_MES_NAVBAR_APP_ID_FOR_WHATSNEW_TEXT} from '@gea-mes/navbar';

import { NavItem } from './nav-item.service';
import { BehaviorSubject } from "rxjs";
import { AdminHomeComponent } from './admin/components/admin-home/admin-home.component';
import { ScreenAuthComponent } from './admin/components/screen-auth/screen-auth.component';
import { ScreenAuthStatusComponent } from './admin/components/screen-auth-status/screen-auth-status.component';
import { LogOutPageComponent} from './log-out-page/log-out-page.component';
import { HomeComponent} from './home/home.component';

export const routes: Routes = [

  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: GeaMesLogoutComponent },
  { path: 'accessdenied', component: GeaMesAccessDeniedComponent },
  {
    path: '', canActivate: [GeaMesCognitoAuthGuard],
    children: [

      { path: '', redirectTo: '/manufacturing', pathMatch: 'full' },
      { path: 'manufacturing', component: HomeComponent, data:{ routeStr: 'manufacturing' }},
      { path: 'distribution', component: HomeComponent, data:{ routeStr: 'distribution' }},
      { path: 'reports', component: HomeComponent, data:{ routeStr: 'reports' }},
      {
        path: 'admin',
        children: [
          { path: '', component: AdminHomeComponent },
          { path: 'screenauth', component: ScreenAuthComponent },
          { path: 'screenauthstatus', component: ScreenAuthStatusComponent },
        ]
      },
    ],
  },

  { path: 'logout', component: LogOutPageComponent},
  { path: '**', redirectTo: '/manufacturing' },

];